import React from 'react';
import './Tag.css';

const Tag = ({ text }) => {
    return <span className="tag">{text}</span>;
};

export default Tag;